import { Tree, Spin, theme } from "antd";

const BlogTreeSelector = ({ selectedNode, setSelectedNode, isLoading, treeData }) => {
  const {
    token: { colorBorderSecondary }
  } = theme.useToken();

  if (isLoading) {
    return <Spin />;
  }
  return (
    <div
      style={{
        width: "min(350px, 100%)",
        borderRight: `1px solid ${colorBorderSecondary}`,
        paddingRight: "20px"
      }}
    >
      <Tree
        treeData={treeData}
        defaultExpandAll
        selectedKeys={[selectedNode]}
        onSelect={(keys) => {
          if (keys.length > 0) {
            setSelectedNode(keys[0]);
          }
        }}
      />
    </div>
  );
};

export default BlogTreeSelector;
